import { PatientPackageViewModel_get_empty } from "../ThreeDocs.Models/View/PatientPackageViewModel.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.25.0/Result.js";
import { Msg, Model } from "./PatientPackagesTypes.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { Cmd_OfAsyncWith_either } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { AsyncHelpers_start } from "../fable_modules/Fable.Elmish.4.4.0/prelude.fs.js";
import { publicPatientPackagesApi } from "../Api.js";
import { error } from "../ThreeDocs.SharedUI/Toast.js";
import { ErrorMessage_get_describe } from "../ThreeDocs.Models/Api/Api.js";
import { some } from "../fable_modules/fable-library-js.4.25.0/Option.js";

export function init(packageIdToken) {
    return [new Model(packageIdToken, new FSharpResult$2(0, [PatientPackageViewModel_get_empty()])), Cmd_none()];
}

export function update(msg, model) {
    switch (msg.tag) {
        case 1:
            return [model, Cmd_OfAsyncWith_either((x) => {
                AsyncHelpers_start(x);
            }, publicPatientPackagesApi.getPatientPackage, msg.fields[0], (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(0, [Item_1])))];
        case 2:
            if (msg.fields[0].tag === 1) {
                return [new Model(model.token, new FSharpResult$2(1, [msg.fields[0].fields[0]])), error(ErrorMessage_get_describe()(msg.fields[0].fields[0]))];
            }
            else {
                return [new Model(model.token, new FSharpResult$2(0, [msg.fields[0].fields[0]])), Cmd_none()];
            }
        default: {
            console.error(some(msg.fields[0]));
            return [model, Cmd_none()];
        }
    }
}

